<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <AddChannelMarkers stage3></AddChannelMarkers>
            <div class="mt-12 d-flex justify-center" v-if="isLoading">
                <v-progress-circular indeterminate color="mainNew"></v-progress-circular>
            </div>
            <div v-else-if="connector">
                <!-- Если это WhatsApp (рассылки), показываем компонент настроек коннектора -->
                <component
                    v-if="isWhatsappMailing && activeComponent"
                    @createConnector="createConnector"
                    @cancel="cancel"
                    @endSettings="goToProject"
                    :is="activeComponent"
                    :isChange="false"
                    :connector="connector"
                ></component>
                <!-- Для остальных каналов показываем ChannelSettingsForm -->
                <ChannelSettingsForm
                    v-else-if="providerType"
                    :value="settings"
                    :connector="connector"
                    :providerType="providerType"
                    :appCreated="appCreated"
                    @input="settings = $event"
                />
            </div>
            <div v-else>
                <h2 class="dashboard mt-12">
                    Ошибка: коннектор не найден
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
import AddChannelMarkers from '@/components/addConnector/AddChannelMarkers.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import settingsList from '@/components/connectorSettings/list'
import { CONNECTOR_TYPES, PROVIDER_TYPES } from '@/vars/general'

export default {
    name: 'AddChannelStage3',
    components: {
        AddChannelMarkers,
        Breadcrumbs,
        ChannelSettingsForm: () => import('@/components/channels/ChannelSettingsForm.vue'),
    },
    data: () => ({
        isLoading: false,
        settings: {},
        appCreated: true,
    }),
    computed: {
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        connector() {
            // Получаем коннектор из store
            const loggedConnector = this.$store.state.project.loggedAddingConnector
            if (loggedConnector) {
                return loggedConnector
            }
            // Или из currentAddingConnector
            const currentConnector = this.$store.state.project.currentAddingConnector
            if (currentConnector) {
                return currentConnector
            }
            // Или из connectorId в маршруте
            const connectorId = this.$router.currentRoute.params.connectorId
            if (connectorId) {
                return this.$store.getters['connectorById'](connectorId)
            }
            return null
        },
        providerType() {
            // Получаем providerType из connector или из currentAddingConnector
            if (this.connector?.providerType) {
                return this.connector.providerType
            }
            if (this.$store.state.project.currentAddingConnector?.providerType) {
                return this.$store.state.project.currentAddingConnector.providerType
            }
            return null
        },
        isWhatsappMailing() {
            // Проверяем, является ли это WhatsApp (рассылки)
            const currentConnector = this.$store.state.project.currentAddingConnector
            if (currentConnector?.isWhatsappMailing) {
                return true
            }
            if (this.connector?.connectorType === CONNECTOR_TYPES.whatsapp) {
                return true
            }
            return false
        },
        activeComponent() {
            // Если это WhatsApp (рассылки), возвращаем компонент настроек коннектора
            if (this.isWhatsappMailing) {
                return settingsList.find(el => el.connectorType === CONNECTOR_TYPES.whatsapp)?.component
            }
            return null
        },
        breadcrumbs() {
            if (!this.project) {
                return []
            }
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'ПОДКЛЮЧЕНИЕ КАНАЛА',
                    disabled: true,
                    to: '',
                },
            ]
        },
    },
    methods: {
        createConnector() {
            this.$emit('createConnector', {})
        },
        cancel() {
            const projectId = this.$router.currentRoute.params.id
            this.$router.push(`/project/${projectId}`)
        },
        goToProject() {
            const projectId = this.$router.currentRoute.params.id
            this.$router.push(`/project/${projectId}#connectors`)
        },
    },
    created() {
        // На этом этапе просто подключаем канал к номеру, настройки не нужны
    },
}
</script>

<style lang="sass" scoped></style>


